import './assets/styles/main.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persistedstate' //Pinia 持久化插件 可以把狀態儲存到 localStorage
import App from './App.vue'
import router from './router'

// import VConsole from 'vconsole'
// new VConsole({ theme: 'dark' })

import './assets/styles/bootstrap-custom.scss'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
// animate.css
import 'animate.css'
import './assets/styles/fonts.css'

// 安裝的 vue-select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

// 建立應用實例
const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPersist)

// 使用 router（必須在 mount 之前）
app.use(pinia)
app.use(router)

// 註冊 vue-select 元件
app.component('v-select', vSelect)

// 掛載到 DOM
app.mount('#app')
